/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ShellAdditionalWorkRouteImport } from './routes/_shell/additional-work'
import { Route as ShellDashboardRouteImport } from './routes/_shell/dashboard'
import { Route as ShellGroundworkRouteImport } from './routes/_shell/groundwork'
import { Route as ShellIntakeRouteImport } from './routes/_shell/intake'
import { Route as ShellPermissionsRouteImport } from './routes/_shell/permissions'
import { Route as ShellPreferencesRouteImport } from './routes/_shell/preferences'
import { Route as ShellQuotationListsRouteImport } from './routes/_shell/quotation-lists'
import { Route as PortalPortalRouteImport } from './routes/portal/_portal'
import { Route as PortalActivateRouteImport } from './routes/portal/activate'
import { Route as ShellDataOwnersIndexRouteImport } from './routes/_shell/data-owners.index'
import { Route as ShellDataOwnersDataOwnerIdRouteImport } from './routes/_shell/data-owners.$dataOwnerId'
import { Route as ShellFuelEmissionFactorsRouteImport } from './routes/_shell/fuel.emission-factors'
import { Route as ShellFuelEntriesRouteImport } from './routes/_shell/fuel.entries'
import { Route as ShellFuelHomebasesRouteImport } from './routes/_shell/fuel.homebases'
import { Route as ShellFuelOwnersRouteImport } from './routes/_shell/fuel.owners'
import { Route as ShellFuelSuppliersRouteImport } from './routes/_shell/fuel.suppliers'
import { Route as ShellLogisticsLoadingPlacesRouteImport } from './routes/_shell/logistics.loading-places'
import { Route as ShellLogisticsStagingRouteImport } from './routes/_shell/logistics.staging'
import { Route as ShellOrdersIndexRouteImport } from './routes/_shell/orders.index'
import { Route as ShellOrdersOrderIdRouteImport } from './routes/_shell/orders.$orderId'
import { Route as ShellQuotationsIndexRouteImport } from './routes/_shell/quotations.index'
import { Route as ShellQuotationsQuotationIdRouteImport } from './routes/_shell/quotations.$quotationId'
import { Route as ShellQuotationsNewRouteImport } from './routes/_shell/quotations.new'
import { Route as ShellRelationsIndexRouteImport } from './routes/_shell/relations.index'
import { Route as ShellRelationsRelationIdRouteImport } from './routes/_shell/relations.$relationId'
import { Route as ShellStorageDashboardRouteImport } from './routes/_shell/storage.dashboard'
import { Route as ShellStorageOwnersRouteImport } from './routes/_shell/storage.owners'
import { Route as ShellStorageStationTypesRouteImport } from './routes/_shell/storage.station-types'
import { Route as ShellUsersIndexRouteImport } from './routes/_shell/users.index'
import { Route as ShellUsersUserIdRouteImport } from './routes/_shell/users.$userId'
import { Route as PortalPortalIndexRouteImport } from './routes/portal/_portal/index'
import { Route as PortalPortalAccountRouteImport } from './routes/portal/_portal/account'
import { Route as PortalPortalGroundworkRouteImport } from './routes/portal/_portal/groundwork'
import { Route as PortalPortalNewPhoneRouteImport } from './routes/portal/_portal/new-phone'
import { Route as ShellFuelVehiclesIndexRouteImport } from './routes/_shell/fuel.vehicles.index'
import { Route as ShellFuelVehiclesVehicleIdRouteImport } from './routes/_shell/fuel.vehicles.$vehicleId'
import { Route as ShellStorageFloorplanSettingsFloorplanIdRouteImport } from './routes/_shell/storage.floorplan-settings.$floorplanId'
import { Route as ShellStorageFloorplanSettingsNewRouteImport } from './routes/_shell/storage.floorplan-settings.new'
import { Route as ShellStorageFloorplansIndexRouteImport } from './routes/_shell/storage.floorplans.index'
import { Route as ShellStorageFloorplansFloorplanIdRouteImport } from './routes/_shell/storage.floorplans.$floorplanId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellAdditionalWorkRoute = ShellAdditionalWorkRouteImport.update({
  id: '/additional-work',
  path: '/additional-work',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDashboardRoute = ShellDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ShellRoute,
} as any)
const ShellGroundworkRoute = ShellGroundworkRouteImport.update({
  id: '/groundwork',
  path: '/groundwork',
  getParentRoute: () => ShellRoute,
} as any)
const ShellIntakeRoute = ShellIntakeRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPermissionsRoute = ShellPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPreferencesRoute = ShellPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => ShellRoute,
} as any)
const ShellQuotationListsRoute = ShellQuotationListsRouteImport.update({
  id: '/quotation-lists',
  path: '/quotation-lists',
  getParentRoute: () => ShellRoute,
} as any)
const PortalPortalRoute = PortalPortalRouteImport.update({
  id: '/portal/_portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalActivateRoute = PortalActivateRouteImport.update({
  id: '/portal/activate',
  path: '/portal/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellDataOwnersIndexRoute = ShellDataOwnersIndexRouteImport.update({
  id: '/data-owners/',
  path: '/data-owners/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDataOwnersDataOwnerIdRoute =
  ShellDataOwnersDataOwnerIdRouteImport.update({
    id: '/data-owners/$dataOwnerId',
    path: '/data-owners/$dataOwnerId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellFuelEmissionFactorsRoute =
  ShellFuelEmissionFactorsRouteImport.update({
    id: '/fuel/emission-factors',
    path: '/fuel/emission-factors',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellFuelEntriesRoute = ShellFuelEntriesRouteImport.update({
  id: '/fuel/entries',
  path: '/fuel/entries',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFuelHomebasesRoute = ShellFuelHomebasesRouteImport.update({
  id: '/fuel/homebases',
  path: '/fuel/homebases',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFuelOwnersRoute = ShellFuelOwnersRouteImport.update({
  id: '/fuel/owners',
  path: '/fuel/owners',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFuelSuppliersRoute = ShellFuelSuppliersRouteImport.update({
  id: '/fuel/suppliers',
  path: '/fuel/suppliers',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLogisticsLoadingPlacesRoute =
  ShellLogisticsLoadingPlacesRouteImport.update({
    id: '/logistics/loading-places',
    path: '/logistics/loading-places',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellLogisticsStagingRoute = ShellLogisticsStagingRouteImport.update({
  id: '/logistics/staging',
  path: '/logistics/staging',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrdersIndexRoute = ShellOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrdersOrderIdRoute = ShellOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellQuotationsIndexRoute = ShellQuotationsIndexRouteImport.update({
  id: '/quotations/',
  path: '/quotations/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellQuotationsQuotationIdRoute =
  ShellQuotationsQuotationIdRouteImport.update({
    id: '/quotations/$quotationId',
    path: '/quotations/$quotationId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellQuotationsNewRoute = ShellQuotationsNewRouteImport.update({
  id: '/quotations/new',
  path: '/quotations/new',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRelationsIndexRoute = ShellRelationsIndexRouteImport.update({
  id: '/relations/',
  path: '/relations/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRelationsRelationIdRoute =
  ShellRelationsRelationIdRouteImport.update({
    id: '/relations/$relationId',
    path: '/relations/$relationId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellStorageDashboardRoute = ShellStorageDashboardRouteImport.update({
  id: '/storage/dashboard',
  path: '/storage/dashboard',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStorageOwnersRoute = ShellStorageOwnersRouteImport.update({
  id: '/storage/owners',
  path: '/storage/owners',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStorageStationTypesRoute =
  ShellStorageStationTypesRouteImport.update({
    id: '/storage/station-types',
    path: '/storage/station-types',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellUsersIndexRoute = ShellUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellUsersUserIdRoute = ShellUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => ShellRoute,
} as any)
const PortalPortalIndexRoute = PortalPortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalPortalRoute,
} as any)
const PortalPortalAccountRoute = PortalPortalAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => PortalPortalRoute,
} as any)
const PortalPortalGroundworkRoute = PortalPortalGroundworkRouteImport.update({
  id: '/groundwork',
  path: '/groundwork',
  getParentRoute: () => PortalPortalRoute,
} as any)
const PortalPortalNewPhoneRoute = PortalPortalNewPhoneRouteImport.update({
  id: '/new-phone',
  path: '/new-phone',
  getParentRoute: () => PortalPortalRoute,
} as any)
const ShellFuelVehiclesIndexRoute = ShellFuelVehiclesIndexRouteImport.update({
  id: '/fuel/vehicles/',
  path: '/fuel/vehicles/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFuelVehiclesVehicleIdRoute =
  ShellFuelVehiclesVehicleIdRouteImport.update({
    id: '/fuel/vehicles/$vehicleId',
    path: '/fuel/vehicles/$vehicleId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellStorageFloorplanSettingsFloorplanIdRoute =
  ShellStorageFloorplanSettingsFloorplanIdRouteImport.update({
    id: '/storage/floorplan-settings/$floorplanId',
    path: '/storage/floorplan-settings/$floorplanId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellStorageFloorplanSettingsNewRoute =
  ShellStorageFloorplanSettingsNewRouteImport.update({
    id: '/storage/floorplan-settings/new',
    path: '/storage/floorplan-settings/new',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellStorageFloorplansIndexRoute =
  ShellStorageFloorplansIndexRouteImport.update({
    id: '/storage/floorplans/',
    path: '/storage/floorplans/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellStorageFloorplansFloorplanIdRoute =
  ShellStorageFloorplansFloorplanIdRouteImport.update({
    id: '/storage/floorplans/$floorplanId',
    path: '/storage/floorplans/$floorplanId',
    getParentRoute: () => ShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/additional-work': typeof ShellAdditionalWorkRoute
  '/dashboard': typeof ShellDashboardRoute
  '/groundwork': typeof ShellGroundworkRoute
  '/intake': typeof ShellIntakeRoute
  '/permissions': typeof ShellPermissionsRoute
  '/preferences': typeof ShellPreferencesRoute
  '/quotation-lists': typeof ShellQuotationListsRoute
  '/portal': typeof PortalPortalRouteWithChildren
  '/portal/activate': typeof PortalActivateRoute
  '/data-owners/$dataOwnerId': typeof ShellDataOwnersDataOwnerIdRoute
  '/fuel/emission-factors': typeof ShellFuelEmissionFactorsRoute
  '/fuel/entries': typeof ShellFuelEntriesRoute
  '/fuel/homebases': typeof ShellFuelHomebasesRoute
  '/fuel/owners': typeof ShellFuelOwnersRoute
  '/fuel/suppliers': typeof ShellFuelSuppliersRoute
  '/logistics/loading-places': typeof ShellLogisticsLoadingPlacesRoute
  '/logistics/staging': typeof ShellLogisticsStagingRoute
  '/orders/$orderId': typeof ShellOrdersOrderIdRoute
  '/quotations/$quotationId': typeof ShellQuotationsQuotationIdRoute
  '/quotations/new': typeof ShellQuotationsNewRoute
  '/relations/$relationId': typeof ShellRelationsRelationIdRoute
  '/storage/dashboard': typeof ShellStorageDashboardRoute
  '/storage/owners': typeof ShellStorageOwnersRoute
  '/storage/station-types': typeof ShellStorageStationTypesRoute
  '/users/$userId': typeof ShellUsersUserIdRoute
  '/portal/account': typeof PortalPortalAccountRoute
  '/portal/groundwork': typeof PortalPortalGroundworkRoute
  '/portal/new-phone': typeof PortalPortalNewPhoneRoute
  '/data-owners/': typeof ShellDataOwnersIndexRoute
  '/orders/': typeof ShellOrdersIndexRoute
  '/quotations/': typeof ShellQuotationsIndexRoute
  '/relations/': typeof ShellRelationsIndexRoute
  '/users/': typeof ShellUsersIndexRoute
  '/portal/': typeof PortalPortalIndexRoute
  '/fuel/vehicles/$vehicleId': typeof ShellFuelVehiclesVehicleIdRoute
  '/storage/floorplan-settings/$floorplanId': typeof ShellStorageFloorplanSettingsFloorplanIdRoute
  '/storage/floorplan-settings/new': typeof ShellStorageFloorplanSettingsNewRoute
  '/storage/floorplans/$floorplanId': typeof ShellStorageFloorplansFloorplanIdRoute
  '/fuel/vehicles/': typeof ShellFuelVehiclesIndexRoute
  '/storage/floorplans/': typeof ShellStorageFloorplansIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/additional-work': typeof ShellAdditionalWorkRoute
  '/dashboard': typeof ShellDashboardRoute
  '/groundwork': typeof ShellGroundworkRoute
  '/intake': typeof ShellIntakeRoute
  '/permissions': typeof ShellPermissionsRoute
  '/preferences': typeof ShellPreferencesRoute
  '/quotation-lists': typeof ShellQuotationListsRoute
  '/portal/activate': typeof PortalActivateRoute
  '/data-owners/$dataOwnerId': typeof ShellDataOwnersDataOwnerIdRoute
  '/fuel/emission-factors': typeof ShellFuelEmissionFactorsRoute
  '/fuel/entries': typeof ShellFuelEntriesRoute
  '/fuel/homebases': typeof ShellFuelHomebasesRoute
  '/fuel/owners': typeof ShellFuelOwnersRoute
  '/fuel/suppliers': typeof ShellFuelSuppliersRoute
  '/logistics/loading-places': typeof ShellLogisticsLoadingPlacesRoute
  '/logistics/staging': typeof ShellLogisticsStagingRoute
  '/orders/$orderId': typeof ShellOrdersOrderIdRoute
  '/quotations/$quotationId': typeof ShellQuotationsQuotationIdRoute
  '/quotations/new': typeof ShellQuotationsNewRoute
  '/relations/$relationId': typeof ShellRelationsRelationIdRoute
  '/storage/dashboard': typeof ShellStorageDashboardRoute
  '/storage/owners': typeof ShellStorageOwnersRoute
  '/storage/station-types': typeof ShellStorageStationTypesRoute
  '/users/$userId': typeof ShellUsersUserIdRoute
  '/portal/account': typeof PortalPortalAccountRoute
  '/portal/groundwork': typeof PortalPortalGroundworkRoute
  '/portal/new-phone': typeof PortalPortalNewPhoneRoute
  '/data-owners': typeof ShellDataOwnersIndexRoute
  '/orders': typeof ShellOrdersIndexRoute
  '/quotations': typeof ShellQuotationsIndexRoute
  '/relations': typeof ShellRelationsIndexRoute
  '/users': typeof ShellUsersIndexRoute
  '/portal': typeof PortalPortalIndexRoute
  '/fuel/vehicles/$vehicleId': typeof ShellFuelVehiclesVehicleIdRoute
  '/storage/floorplan-settings/$floorplanId': typeof ShellStorageFloorplanSettingsFloorplanIdRoute
  '/storage/floorplan-settings/new': typeof ShellStorageFloorplanSettingsNewRoute
  '/storage/floorplans/$floorplanId': typeof ShellStorageFloorplansFloorplanIdRoute
  '/fuel/vehicles': typeof ShellFuelVehiclesIndexRoute
  '/storage/floorplans': typeof ShellStorageFloorplansIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_shell': typeof ShellRouteWithChildren
  '/login': typeof LoginRoute
  '/_shell/additional-work': typeof ShellAdditionalWorkRoute
  '/_shell/dashboard': typeof ShellDashboardRoute
  '/_shell/groundwork': typeof ShellGroundworkRoute
  '/_shell/intake': typeof ShellIntakeRoute
  '/_shell/permissions': typeof ShellPermissionsRoute
  '/_shell/preferences': typeof ShellPreferencesRoute
  '/_shell/quotation-lists': typeof ShellQuotationListsRoute
  '/portal/_portal': typeof PortalPortalRouteWithChildren
  '/portal/activate': typeof PortalActivateRoute
  '/_shell/data-owners/$dataOwnerId': typeof ShellDataOwnersDataOwnerIdRoute
  '/_shell/fuel/emission-factors': typeof ShellFuelEmissionFactorsRoute
  '/_shell/fuel/entries': typeof ShellFuelEntriesRoute
  '/_shell/fuel/homebases': typeof ShellFuelHomebasesRoute
  '/_shell/fuel/owners': typeof ShellFuelOwnersRoute
  '/_shell/fuel/suppliers': typeof ShellFuelSuppliersRoute
  '/_shell/logistics/loading-places': typeof ShellLogisticsLoadingPlacesRoute
  '/_shell/logistics/staging': typeof ShellLogisticsStagingRoute
  '/_shell/orders/$orderId': typeof ShellOrdersOrderIdRoute
  '/_shell/quotations/$quotationId': typeof ShellQuotationsQuotationIdRoute
  '/_shell/quotations/new': typeof ShellQuotationsNewRoute
  '/_shell/relations/$relationId': typeof ShellRelationsRelationIdRoute
  '/_shell/storage/dashboard': typeof ShellStorageDashboardRoute
  '/_shell/storage/owners': typeof ShellStorageOwnersRoute
  '/_shell/storage/station-types': typeof ShellStorageStationTypesRoute
  '/_shell/users/$userId': typeof ShellUsersUserIdRoute
  '/portal/_portal/account': typeof PortalPortalAccountRoute
  '/portal/_portal/groundwork': typeof PortalPortalGroundworkRoute
  '/portal/_portal/new-phone': typeof PortalPortalNewPhoneRoute
  '/_shell/data-owners/': typeof ShellDataOwnersIndexRoute
  '/_shell/orders/': typeof ShellOrdersIndexRoute
  '/_shell/quotations/': typeof ShellQuotationsIndexRoute
  '/_shell/relations/': typeof ShellRelationsIndexRoute
  '/_shell/users/': typeof ShellUsersIndexRoute
  '/portal/_portal/': typeof PortalPortalIndexRoute
  '/_shell/fuel/vehicles/$vehicleId': typeof ShellFuelVehiclesVehicleIdRoute
  '/_shell/storage/floorplan-settings/$floorplanId': typeof ShellStorageFloorplanSettingsFloorplanIdRoute
  '/_shell/storage/floorplan-settings/new': typeof ShellStorageFloorplanSettingsNewRoute
  '/_shell/storage/floorplans/$floorplanId': typeof ShellStorageFloorplansFloorplanIdRoute
  '/_shell/fuel/vehicles/': typeof ShellFuelVehiclesIndexRoute
  '/_shell/storage/floorplans/': typeof ShellStorageFloorplansIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/additional-work'
    | '/dashboard'
    | '/groundwork'
    | '/intake'
    | '/permissions'
    | '/preferences'
    | '/quotation-lists'
    | '/portal'
    | '/portal/activate'
    | '/data-owners/$dataOwnerId'
    | '/fuel/emission-factors'
    | '/fuel/entries'
    | '/fuel/homebases'
    | '/fuel/owners'
    | '/fuel/suppliers'
    | '/logistics/loading-places'
    | '/logistics/staging'
    | '/orders/$orderId'
    | '/quotations/$quotationId'
    | '/quotations/new'
    | '/relations/$relationId'
    | '/storage/dashboard'
    | '/storage/owners'
    | '/storage/station-types'
    | '/users/$userId'
    | '/portal/account'
    | '/portal/groundwork'
    | '/portal/new-phone'
    | '/data-owners/'
    | '/orders/'
    | '/quotations/'
    | '/relations/'
    | '/users/'
    | '/portal/'
    | '/fuel/vehicles/$vehicleId'
    | '/storage/floorplan-settings/$floorplanId'
    | '/storage/floorplan-settings/new'
    | '/storage/floorplans/$floorplanId'
    | '/fuel/vehicles/'
    | '/storage/floorplans/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/additional-work'
    | '/dashboard'
    | '/groundwork'
    | '/intake'
    | '/permissions'
    | '/preferences'
    | '/quotation-lists'
    | '/portal/activate'
    | '/data-owners/$dataOwnerId'
    | '/fuel/emission-factors'
    | '/fuel/entries'
    | '/fuel/homebases'
    | '/fuel/owners'
    | '/fuel/suppliers'
    | '/logistics/loading-places'
    | '/logistics/staging'
    | '/orders/$orderId'
    | '/quotations/$quotationId'
    | '/quotations/new'
    | '/relations/$relationId'
    | '/storage/dashboard'
    | '/storage/owners'
    | '/storage/station-types'
    | '/users/$userId'
    | '/portal/account'
    | '/portal/groundwork'
    | '/portal/new-phone'
    | '/data-owners'
    | '/orders'
    | '/quotations'
    | '/relations'
    | '/users'
    | '/portal'
    | '/fuel/vehicles/$vehicleId'
    | '/storage/floorplan-settings/$floorplanId'
    | '/storage/floorplan-settings/new'
    | '/storage/floorplans/$floorplanId'
    | '/fuel/vehicles'
    | '/storage/floorplans'
  id:
    | '__root__'
    | '/'
    | '/_shell'
    | '/login'
    | '/_shell/additional-work'
    | '/_shell/dashboard'
    | '/_shell/groundwork'
    | '/_shell/intake'
    | '/_shell/permissions'
    | '/_shell/preferences'
    | '/_shell/quotation-lists'
    | '/portal/_portal'
    | '/portal/activate'
    | '/_shell/data-owners/$dataOwnerId'
    | '/_shell/fuel/emission-factors'
    | '/_shell/fuel/entries'
    | '/_shell/fuel/homebases'
    | '/_shell/fuel/owners'
    | '/_shell/fuel/suppliers'
    | '/_shell/logistics/loading-places'
    | '/_shell/logistics/staging'
    | '/_shell/orders/$orderId'
    | '/_shell/quotations/$quotationId'
    | '/_shell/quotations/new'
    | '/_shell/relations/$relationId'
    | '/_shell/storage/dashboard'
    | '/_shell/storage/owners'
    | '/_shell/storage/station-types'
    | '/_shell/users/$userId'
    | '/portal/_portal/account'
    | '/portal/_portal/groundwork'
    | '/portal/_portal/new-phone'
    | '/_shell/data-owners/'
    | '/_shell/orders/'
    | '/_shell/quotations/'
    | '/_shell/relations/'
    | '/_shell/users/'
    | '/portal/_portal/'
    | '/_shell/fuel/vehicles/$vehicleId'
    | '/_shell/storage/floorplan-settings/$floorplanId'
    | '/_shell/storage/floorplan-settings/new'
    | '/_shell/storage/floorplans/$floorplanId'
    | '/_shell/fuel/vehicles/'
    | '/_shell/storage/floorplans/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ShellRoute: typeof ShellRouteWithChildren
  LoginRoute: typeof LoginRoute
  PortalPortalRoute: typeof PortalPortalRouteWithChildren
  PortalActivateRoute: typeof PortalActivateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/additional-work': {
      id: '/_shell/additional-work'
      path: '/additional-work'
      fullPath: '/additional-work'
      preLoaderRoute: typeof ShellAdditionalWorkRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/dashboard': {
      id: '/_shell/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ShellDashboardRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/groundwork': {
      id: '/_shell/groundwork'
      path: '/groundwork'
      fullPath: '/groundwork'
      preLoaderRoute: typeof ShellGroundworkRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/intake': {
      id: '/_shell/intake'
      path: '/intake'
      fullPath: '/intake'
      preLoaderRoute: typeof ShellIntakeRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/permissions': {
      id: '/_shell/permissions'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof ShellPermissionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/preferences': {
      id: '/_shell/preferences'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof ShellPreferencesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/quotation-lists': {
      id: '/_shell/quotation-lists'
      path: '/quotation-lists'
      fullPath: '/quotation-lists'
      preLoaderRoute: typeof ShellQuotationListsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/portal/_portal': {
      id: '/portal/_portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalPortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/activate': {
      id: '/portal/activate'
      path: '/portal/activate'
      fullPath: '/portal/activate'
      preLoaderRoute: typeof PortalActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/data-owners/': {
      id: '/_shell/data-owners/'
      path: '/data-owners'
      fullPath: '/data-owners/'
      preLoaderRoute: typeof ShellDataOwnersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/data-owners/$dataOwnerId': {
      id: '/_shell/data-owners/$dataOwnerId'
      path: '/data-owners/$dataOwnerId'
      fullPath: '/data-owners/$dataOwnerId'
      preLoaderRoute: typeof ShellDataOwnersDataOwnerIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/fuel/emission-factors': {
      id: '/_shell/fuel/emission-factors'
      path: '/fuel/emission-factors'
      fullPath: '/fuel/emission-factors'
      preLoaderRoute: typeof ShellFuelEmissionFactorsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/fuel/entries': {
      id: '/_shell/fuel/entries'
      path: '/fuel/entries'
      fullPath: '/fuel/entries'
      preLoaderRoute: typeof ShellFuelEntriesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/fuel/homebases': {
      id: '/_shell/fuel/homebases'
      path: '/fuel/homebases'
      fullPath: '/fuel/homebases'
      preLoaderRoute: typeof ShellFuelHomebasesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/fuel/owners': {
      id: '/_shell/fuel/owners'
      path: '/fuel/owners'
      fullPath: '/fuel/owners'
      preLoaderRoute: typeof ShellFuelOwnersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/fuel/suppliers': {
      id: '/_shell/fuel/suppliers'
      path: '/fuel/suppliers'
      fullPath: '/fuel/suppliers'
      preLoaderRoute: typeof ShellFuelSuppliersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/logistics/loading-places': {
      id: '/_shell/logistics/loading-places'
      path: '/logistics/loading-places'
      fullPath: '/logistics/loading-places'
      preLoaderRoute: typeof ShellLogisticsLoadingPlacesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/logistics/staging': {
      id: '/_shell/logistics/staging'
      path: '/logistics/staging'
      fullPath: '/logistics/staging'
      preLoaderRoute: typeof ShellLogisticsStagingRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/orders/': {
      id: '/_shell/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof ShellOrdersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/orders/$orderId': {
      id: '/_shell/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof ShellOrdersOrderIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/quotations/': {
      id: '/_shell/quotations/'
      path: '/quotations'
      fullPath: '/quotations/'
      preLoaderRoute: typeof ShellQuotationsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/quotations/$quotationId': {
      id: '/_shell/quotations/$quotationId'
      path: '/quotations/$quotationId'
      fullPath: '/quotations/$quotationId'
      preLoaderRoute: typeof ShellQuotationsQuotationIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/quotations/new': {
      id: '/_shell/quotations/new'
      path: '/quotations/new'
      fullPath: '/quotations/new'
      preLoaderRoute: typeof ShellQuotationsNewRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/relations/': {
      id: '/_shell/relations/'
      path: '/relations'
      fullPath: '/relations/'
      preLoaderRoute: typeof ShellRelationsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/relations/$relationId': {
      id: '/_shell/relations/$relationId'
      path: '/relations/$relationId'
      fullPath: '/relations/$relationId'
      preLoaderRoute: typeof ShellRelationsRelationIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/storage/dashboard': {
      id: '/_shell/storage/dashboard'
      path: '/storage/dashboard'
      fullPath: '/storage/dashboard'
      preLoaderRoute: typeof ShellStorageDashboardRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/storage/owners': {
      id: '/_shell/storage/owners'
      path: '/storage/owners'
      fullPath: '/storage/owners'
      preLoaderRoute: typeof ShellStorageOwnersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/storage/station-types': {
      id: '/_shell/storage/station-types'
      path: '/storage/station-types'
      fullPath: '/storage/station-types'
      preLoaderRoute: typeof ShellStorageStationTypesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/users/': {
      id: '/_shell/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof ShellUsersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/users/$userId': {
      id: '/_shell/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof ShellUsersUserIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/portal/_portal/': {
      id: '/portal/_portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalPortalIndexRouteImport
      parentRoute: typeof PortalPortalRoute
    }
    '/portal/_portal/account': {
      id: '/portal/_portal/account'
      path: '/account'
      fullPath: '/portal/account'
      preLoaderRoute: typeof PortalPortalAccountRouteImport
      parentRoute: typeof PortalPortalRoute
    }
    '/portal/_portal/groundwork': {
      id: '/portal/_portal/groundwork'
      path: '/groundwork'
      fullPath: '/portal/groundwork'
      preLoaderRoute: typeof PortalPortalGroundworkRouteImport
      parentRoute: typeof PortalPortalRoute
    }
    '/portal/_portal/new-phone': {
      id: '/portal/_portal/new-phone'
      path: '/new-phone'
      fullPath: '/portal/new-phone'
      preLoaderRoute: typeof PortalPortalNewPhoneRouteImport
      parentRoute: typeof PortalPortalRoute
    }
    '/_shell/fuel/vehicles/': {
      id: '/_shell/fuel/vehicles/'
      path: '/fuel/vehicles'
      fullPath: '/fuel/vehicles/'
      preLoaderRoute: typeof ShellFuelVehiclesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/fuel/vehicles/$vehicleId': {
      id: '/_shell/fuel/vehicles/$vehicleId'
      path: '/fuel/vehicles/$vehicleId'
      fullPath: '/fuel/vehicles/$vehicleId'
      preLoaderRoute: typeof ShellFuelVehiclesVehicleIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/storage/floorplan-settings/$floorplanId': {
      id: '/_shell/storage/floorplan-settings/$floorplanId'
      path: '/storage/floorplan-settings/$floorplanId'
      fullPath: '/storage/floorplan-settings/$floorplanId'
      preLoaderRoute: typeof ShellStorageFloorplanSettingsFloorplanIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/storage/floorplan-settings/new': {
      id: '/_shell/storage/floorplan-settings/new'
      path: '/storage/floorplan-settings/new'
      fullPath: '/storage/floorplan-settings/new'
      preLoaderRoute: typeof ShellStorageFloorplanSettingsNewRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/storage/floorplans/': {
      id: '/_shell/storage/floorplans/'
      path: '/storage/floorplans'
      fullPath: '/storage/floorplans/'
      preLoaderRoute: typeof ShellStorageFloorplansIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/storage/floorplans/$floorplanId': {
      id: '/_shell/storage/floorplans/$floorplanId'
      path: '/storage/floorplans/$floorplanId'
      fullPath: '/storage/floorplans/$floorplanId'
      preLoaderRoute: typeof ShellStorageFloorplansFloorplanIdRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellRouteChildren {
  ShellAdditionalWorkRoute: typeof ShellAdditionalWorkRoute
  ShellDashboardRoute: typeof ShellDashboardRoute
  ShellGroundworkRoute: typeof ShellGroundworkRoute
  ShellIntakeRoute: typeof ShellIntakeRoute
  ShellPermissionsRoute: typeof ShellPermissionsRoute
  ShellPreferencesRoute: typeof ShellPreferencesRoute
  ShellQuotationListsRoute: typeof ShellQuotationListsRoute
  ShellDataOwnersDataOwnerIdRoute: typeof ShellDataOwnersDataOwnerIdRoute
  ShellFuelEmissionFactorsRoute: typeof ShellFuelEmissionFactorsRoute
  ShellFuelEntriesRoute: typeof ShellFuelEntriesRoute
  ShellFuelHomebasesRoute: typeof ShellFuelHomebasesRoute
  ShellFuelOwnersRoute: typeof ShellFuelOwnersRoute
  ShellFuelSuppliersRoute: typeof ShellFuelSuppliersRoute
  ShellLogisticsLoadingPlacesRoute: typeof ShellLogisticsLoadingPlacesRoute
  ShellLogisticsStagingRoute: typeof ShellLogisticsStagingRoute
  ShellOrdersOrderIdRoute: typeof ShellOrdersOrderIdRoute
  ShellQuotationsQuotationIdRoute: typeof ShellQuotationsQuotationIdRoute
  ShellQuotationsNewRoute: typeof ShellQuotationsNewRoute
  ShellRelationsRelationIdRoute: typeof ShellRelationsRelationIdRoute
  ShellStorageDashboardRoute: typeof ShellStorageDashboardRoute
  ShellStorageOwnersRoute: typeof ShellStorageOwnersRoute
  ShellStorageStationTypesRoute: typeof ShellStorageStationTypesRoute
  ShellUsersUserIdRoute: typeof ShellUsersUserIdRoute
  ShellDataOwnersIndexRoute: typeof ShellDataOwnersIndexRoute
  ShellOrdersIndexRoute: typeof ShellOrdersIndexRoute
  ShellQuotationsIndexRoute: typeof ShellQuotationsIndexRoute
  ShellRelationsIndexRoute: typeof ShellRelationsIndexRoute
  ShellUsersIndexRoute: typeof ShellUsersIndexRoute
  ShellFuelVehiclesVehicleIdRoute: typeof ShellFuelVehiclesVehicleIdRoute
  ShellStorageFloorplanSettingsFloorplanIdRoute: typeof ShellStorageFloorplanSettingsFloorplanIdRoute
  ShellStorageFloorplanSettingsNewRoute: typeof ShellStorageFloorplanSettingsNewRoute
  ShellStorageFloorplansFloorplanIdRoute: typeof ShellStorageFloorplansFloorplanIdRoute
  ShellFuelVehiclesIndexRoute: typeof ShellFuelVehiclesIndexRoute
  ShellStorageFloorplansIndexRoute: typeof ShellStorageFloorplansIndexRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellAdditionalWorkRoute: ShellAdditionalWorkRoute,
  ShellDashboardRoute: ShellDashboardRoute,
  ShellGroundworkRoute: ShellGroundworkRoute,
  ShellIntakeRoute: ShellIntakeRoute,
  ShellPermissionsRoute: ShellPermissionsRoute,
  ShellPreferencesRoute: ShellPreferencesRoute,
  ShellQuotationListsRoute: ShellQuotationListsRoute,
  ShellDataOwnersDataOwnerIdRoute: ShellDataOwnersDataOwnerIdRoute,
  ShellFuelEmissionFactorsRoute: ShellFuelEmissionFactorsRoute,
  ShellFuelEntriesRoute: ShellFuelEntriesRoute,
  ShellFuelHomebasesRoute: ShellFuelHomebasesRoute,
  ShellFuelOwnersRoute: ShellFuelOwnersRoute,
  ShellFuelSuppliersRoute: ShellFuelSuppliersRoute,
  ShellLogisticsLoadingPlacesRoute: ShellLogisticsLoadingPlacesRoute,
  ShellLogisticsStagingRoute: ShellLogisticsStagingRoute,
  ShellOrdersOrderIdRoute: ShellOrdersOrderIdRoute,
  ShellQuotationsQuotationIdRoute: ShellQuotationsQuotationIdRoute,
  ShellQuotationsNewRoute: ShellQuotationsNewRoute,
  ShellRelationsRelationIdRoute: ShellRelationsRelationIdRoute,
  ShellStorageDashboardRoute: ShellStorageDashboardRoute,
  ShellStorageOwnersRoute: ShellStorageOwnersRoute,
  ShellStorageStationTypesRoute: ShellStorageStationTypesRoute,
  ShellUsersUserIdRoute: ShellUsersUserIdRoute,
  ShellDataOwnersIndexRoute: ShellDataOwnersIndexRoute,
  ShellOrdersIndexRoute: ShellOrdersIndexRoute,
  ShellQuotationsIndexRoute: ShellQuotationsIndexRoute,
  ShellRelationsIndexRoute: ShellRelationsIndexRoute,
  ShellUsersIndexRoute: ShellUsersIndexRoute,
  ShellFuelVehiclesVehicleIdRoute: ShellFuelVehiclesVehicleIdRoute,
  ShellStorageFloorplanSettingsFloorplanIdRoute:
    ShellStorageFloorplanSettingsFloorplanIdRoute,
  ShellStorageFloorplanSettingsNewRoute: ShellStorageFloorplanSettingsNewRoute,
  ShellStorageFloorplansFloorplanIdRoute:
    ShellStorageFloorplansFloorplanIdRoute,
  ShellFuelVehiclesIndexRoute: ShellFuelVehiclesIndexRoute,
  ShellStorageFloorplansIndexRoute: ShellStorageFloorplansIndexRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

interface PortalPortalRouteChildren {
  PortalPortalAccountRoute: typeof PortalPortalAccountRoute
  PortalPortalGroundworkRoute: typeof PortalPortalGroundworkRoute
  PortalPortalNewPhoneRoute: typeof PortalPortalNewPhoneRoute
  PortalPortalIndexRoute: typeof PortalPortalIndexRoute
}

const PortalPortalRouteChildren: PortalPortalRouteChildren = {
  PortalPortalAccountRoute: PortalPortalAccountRoute,
  PortalPortalGroundworkRoute: PortalPortalGroundworkRoute,
  PortalPortalNewPhoneRoute: PortalPortalNewPhoneRoute,
  PortalPortalIndexRoute: PortalPortalIndexRoute,
}

const PortalPortalRouteWithChildren = PortalPortalRoute._addFileChildren(
  PortalPortalRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ShellRoute: ShellRouteWithChildren,
  LoginRoute: LoginRoute,
  PortalPortalRoute: PortalPortalRouteWithChildren,
  PortalActivateRoute: PortalActivateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
